'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useMemo, useEffect, useCallback, useRef } from 'react';
import { useRouter, usePathname, useSearchParams } from 'next/navigation';
import isClient from 'commons/isClient';
import useIsBrowser from 'hooks/useIsBrowser';
import { FACET_FILTER_VALUES } from '../search-state/utils';
const useFilters = () => {
  const $ = _c(79);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isBrowser = useIsBrowser();
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [materialFilter, setMaterialFilter] = useState("");
  const [searchMaterialFilter, setSearchMaterialFilter] = useState("");
  const searchMaterialFilterRef = useRef(searchMaterialFilter);
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams?.get("room") || "";
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const roomFilter = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [colorFilters, setColorFilters] = useState(t1);
  const [photoId, setPhotoId] = useState("");
  const [isMobileFiltersOpen, setIsMobileFiltersOpen] = useState(false);
  const isInitialized = useRef(false);
  let t2;
  let t3;
  if ($[3] !== searchMaterialFilter) {
    t2 = () => {
      searchMaterialFilterRef.current = searchMaterialFilter;
    };
    t3 = [searchMaterialFilter];
    $[3] = searchMaterialFilter;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      if (!isInitialized.current) {
        const params = isClient() ? new URLSearchParams(window.location.search) : new URLSearchParams();
        const material = params.get("material");
        const searchMaterial = params.get("materialOption");
        const color = params.get("color");
        const productId = params.get("pid");
        const productName = params.get("pname");
        const photoIdParam = params.get("photoid");
        if (material) {
          setMaterialFilter(material);
        }
        if (searchMaterial) {
          setSearchMaterialFilter(searchMaterial);
          searchMaterialFilterRef.current = searchMaterial;
          setSearchQuery(searchMaterial);
        }
        if (color) {
          const colorFiltersObj = {};
          const colors = color.includes(",") ? color.split(",") : [color];
          colors.forEach(c => {
            colorFiltersObj[c] = true;
          });
          setColorFilters(colorFiltersObj);
        }
        if (productId && productName) {
          setSelectedProduct({
            id: productId,
            name: productName
          });
          setSearchQuery(productName);
        }
        if (photoIdParam) {
          setPhotoId(photoIdParam);
        }
        isInitialized.current = true;
      }
    };
    t5 = [];
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  const isInitialMount = useRef(true);
  let t6;
  if ($[8] !== colorFilters || $[9] !== isBrowser || $[10] !== materialFilter || $[11] !== photoId || $[12] !== searchMaterialFilter || $[13] !== selectedProduct?.id || $[14] !== selectedProduct?.name) {
    t6 = () => {
      if (isInitialMount.current) {
        isInitialMount.current = false;
        return;
      }
      const newSearch = isBrowser ? new URLSearchParams(window.location.search) : new URLSearchParams();
      const searchParamsObj = {
        pid: selectedProduct?.id || "",
        pname: selectedProduct?.name || "",
        material: materialFilter || "",
        materialOption: searchMaterialFilter || "",
        color: Object.keys(colorFilters).join(",") || "",
        photoid: photoId || ""
      };
      Object.entries(searchParamsObj).forEach(t7 => {
        const [key, value] = t7;
        if (value) {
          newSearch.set(key, value);
        } else {
          newSearch.delete(key);
        }
      });
      const newSearchString = newSearch.toString();
      const currentSearch = isBrowser ? window.location.search.substring(1) : "";
      if (newSearchString !== currentSearch) {
        const newUrl = `${isBrowser ? window.location.pathname : "/customer-photos"}${newSearchString ? `?${newSearchString}` : ""}`;
        if (isBrowser) {
          window.history.pushState(null, "", newUrl);
        }
      }
    };
    $[8] = colorFilters;
    $[9] = isBrowser;
    $[10] = materialFilter;
    $[11] = photoId;
    $[12] = searchMaterialFilter;
    $[13] = selectedProduct?.id;
    $[14] = selectedProduct?.name;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== colorFilters || $[17] !== isBrowser || $[18] !== materialFilter || $[19] !== photoId || $[20] !== searchMaterialFilter || $[21] !== selectedProduct) {
    t7 = [isBrowser, selectedProduct, materialFilter, searchMaterialFilter, colorFilters, photoId];
    $[16] = colorFilters;
    $[17] = isBrowser;
    $[18] = materialFilter;
    $[19] = photoId;
    $[20] = searchMaterialFilter;
    $[21] = selectedProduct;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  useEffect(t6, t7);
  let t8;
  if ($[23] !== isBrowser || $[24] !== pathname || $[25] !== router) {
    t8 = value_0 => {
      if (!isBrowser) {
        return;
      }
      const params_0 = new URLSearchParams(window.location.search);
      if (value_0) {
        params_0.set("room", value_0);
      } else {
        params_0.delete("room");
      }
      const search = params_0.toString();
      router.replace(`${pathname}${search ? `?${search}` : ""}`, {
        scroll: false
      });
    };
    $[23] = isBrowser;
    $[24] = pathname;
    $[25] = router;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  const setRoomFilter = t8;
  let t9;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = color_0 => {
      setColorFilters(prev => {
        const updated = {
          ...prev
        };
        if (updated[color_0]) {
          delete updated[color_0];
        } else {
          updated[color_0] = true;
        }
        return updated;
      });
    };
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  const toggleColorFilter = t9;
  let t10;
  if ($[28] !== photoId) {
    t10 = photoIdValue => {
      const updatedPhotoId = photoId !== photoIdValue ? photoIdValue : "";
      setPhotoId(updatedPhotoId);
    };
    $[28] = photoId;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  const onImageSelect = t10;
  let t11;
  if ($[30] !== isBrowser || $[31] !== pathname || $[32] !== router) {
    t11 = () => {
      setSearchQuery("");
      setSelectedProduct(null);
      setMaterialFilter("");
      setSearchMaterialFilter("");
      setColorFilters({});
      setPhotoId("");
      if (isBrowser) {
        router.replace(pathname, {
          scroll: false
        });
      }
    };
    $[30] = isBrowser;
    $[31] = pathname;
    $[32] = router;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  const clearAllFilters = t11;
  let t12;
  if ($[34] !== colorFilters || $[35] !== materialFilter || $[36] !== roomFilter || $[37] !== selectedProduct) {
    t12 = t13 => {
      const overrides = t13 === undefined ? {} : t13;
      const currentRoomFilter = overrides.roomFilter !== undefined ? overrides.roomFilter : roomFilter;
      const currentMaterialFilter = overrides.materialFilter !== undefined ? overrides.materialFilter : materialFilter;
      const currentSelectedProduct = overrides.selectedProduct !== undefined ? overrides.selectedProduct : selectedProduct;
      const currentColorFilters = overrides.colorFilters !== undefined ? overrides.colorFilters : colorFilters;
      const facetFilters = [];
      if (currentRoomFilter) {
        facetFilters.push(`"${FACET_FILTER_VALUES.room}${currentRoomFilter}"`);
      }
      if (currentMaterialFilter) {
        facetFilters.push(`"${FACET_FILTER_VALUES.material}${currentMaterialFilter}"`);
      }
      if (currentSelectedProduct) {
        facetFilters.push(`"${FACET_FILTER_VALUES.product_id}${currentSelectedProduct.id}"`);
      }
      const colorsKeys = Object.keys(currentColorFilters);
      if (colorsKeys.length) {
        facetFilters.push(`[${colorsKeys.map(_temp).join(",")}]`);
      }
      return facetFilters.length ? `[${facetFilters.join(",")}]` : "";
    };
    $[34] = colorFilters;
    $[35] = materialFilter;
    $[36] = roomFilter;
    $[37] = selectedProduct;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  const buildFacetFilters = t12;
  let t13;
  if ($[39] !== colorFilters || $[40] !== materialFilter || $[41] !== roomFilter || $[42] !== searchMaterialFilter || $[43] !== selectedProduct) {
    t13 = roomFilter || materialFilter || searchMaterialFilter || selectedProduct || Object.keys(colorFilters).length;
    $[39] = colorFilters;
    $[40] = materialFilter;
    $[41] = roomFilter;
    $[42] = searchMaterialFilter;
    $[43] = selectedProduct;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  const isFiltered = !!t13;
  let filters;
  if ($[45] !== searchMaterialFilter || $[46] !== selectedProduct) {
    filters = [];
    if (selectedProduct) {
      let t14;
      if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = () => {
          setSelectedProduct(null);
          setSearchQuery("");
        };
        $[48] = t14;
      } else {
        t14 = $[48];
      }
      let t15;
      if ($[49] !== selectedProduct.name) {
        t15 = {
          filterName: selectedProduct.name,
          onDeselect: t14,
          name: "product"
        };
        $[49] = selectedProduct.name;
        $[50] = t15;
      } else {
        t15 = $[50];
      }
      filters.push(t15);
    }
    if (searchMaterialFilter) {
      let t14;
      if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = () => {
          setSearchMaterialFilter("");
        };
        $[51] = t14;
      } else {
        t14 = $[51];
      }
      let t15;
      if ($[52] !== searchMaterialFilter) {
        t15 = {
          filterName: searchMaterialFilter,
          onDeselect: t14,
          name: "searchMaterial"
        };
        $[52] = searchMaterialFilter;
        $[53] = t15;
      } else {
        t15 = $[53];
      }
      filters.push(t15);
    }
    $[45] = searchMaterialFilter;
    $[46] = selectedProduct;
    $[47] = filters;
  } else {
    filters = $[47];
  }
  const selectedFiltersList = filters;
  const materialFilterCount = materialFilter ? 1 : 0;
  const searchMaterialFilterCount = searchMaterialFilter ? 1 : 0;
  const numberOfActiveFilters = materialFilterCount + searchMaterialFilterCount;
  let t14;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setIsMobileFiltersOpen(true);
    $[54] = t14;
  } else {
    t14 = $[54];
  }
  const openMobileFilters = t14;
  let t15;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => setIsMobileFiltersOpen(false);
    $[55] = t15;
  } else {
    t15 = $[55];
  }
  const closeMobileFilters = t15;
  let t16;
  if ($[56] !== numberOfActiveFilters) {
    t16 = () => numberOfActiveFilters;
    $[56] = numberOfActiveFilters;
    $[57] = t16;
  } else {
    t16 = $[57];
  }
  let t17;
  if ($[58] !== buildFacetFilters || $[59] !== clearAllFilters || $[60] !== onImageSelect || $[61] !== setRoomFilter || $[62] !== t16) {
    t17 = {
      setSearchQuery,
      setSelectedProduct,
      setMaterialFilter,
      setSearchMaterialFilter,
      setRoomFilter,
      toggleColorFilter,
      clearAllFilters,
      getNumberOfActiveFilters: t16,
      buildFacetFilters,
      onImageSelect,
      openMobileFilters,
      closeMobileFilters
    };
    $[58] = buildFacetFilters;
    $[59] = clearAllFilters;
    $[60] = onImageSelect;
    $[61] = setRoomFilter;
    $[62] = t16;
    $[63] = t17;
  } else {
    t17 = $[63];
  }
  const actions = t17;
  let t18;
  if ($[64] !== colorFilters || $[65] !== isFiltered || $[66] !== isMobileFiltersOpen || $[67] !== materialFilter || $[68] !== numberOfActiveFilters || $[69] !== photoId || $[70] !== roomFilter || $[71] !== searchMaterialFilter || $[72] !== searchQuery || $[73] !== selectedFiltersList || $[74] !== selectedProduct) {
    t18 = {
      searchQuery,
      selectedProduct,
      materialFilter,
      searchMaterialFilter,
      roomFilter,
      colorFilters,
      photoId,
      isMobileFiltersOpen,
      selectedFiltersList,
      isFiltered,
      isInitialized,
      numberOfActiveFilters
    };
    $[64] = colorFilters;
    $[65] = isFiltered;
    $[66] = isMobileFiltersOpen;
    $[67] = materialFilter;
    $[68] = numberOfActiveFilters;
    $[69] = photoId;
    $[70] = roomFilter;
    $[71] = searchMaterialFilter;
    $[72] = searchQuery;
    $[73] = selectedFiltersList;
    $[74] = selectedProduct;
    $[75] = t18;
  } else {
    t18 = $[75];
  }
  const state = t18;
  let t19;
  if ($[76] !== actions || $[77] !== state) {
    t19 = {
      state,
      actions
    };
    $[76] = actions;
    $[77] = state;
    $[78] = t19;
  } else {
    t19 = $[78];
  }
  return t19;
};
export default useFilters;
function _temp(color_1) {
  return `"${FACET_FILTER_VALUES.color}${color_1}"`;
}